<template>
  <div>
    <tsl-card :cardList="cardList">
      <template v-slot:needto>
        <div class="need-to">
          <div class="item" v-for="(item, index) in overviewList" :key="index">
            <devops-card :name="item.name" :value="item.value"></devops-card>
          </div>
        </div>
      </template>
      <template v-slot:topRight>
        <div class="backup-time">最近备份：2022/03/19 14:00</div>
      </template>
    </tsl-card>
  </div>
</template>
<script>
import Card from "@/components/tsl-card/index.vue";
import Dcard from "@/components/dashboard/devops/devops-card.vue";
import { reactive, ref } from "vue";
export default {
  name: "need-to",
  components: {
    [Card.name]: Card,
    [Dcard.name]: Dcard
  },
  props: {
    data: Object
  },
  setup() {
    const overviewList = ref([
      {
        name: "待办工单",
        value: 0
      },
      {
        name: "待支付订单",
        value: 0
      },
      {
        name: "待续费项",
        value: 0
      }
    ]);
    const cardList = reactive([
      {
        name: "needto",
        title: "待办"
      }
    ]);
    return {
      cardList,
      overviewList
    };
  }
};
</script>
<style scoped lang="less">
// .backup-timeP {
//   margin-left: 16px;
// }
.need-to {
  display: flex;
  .item {
    width: 100%;
    margin-right: 16px;
  }
  .item:nth-child(3n) {
    margin-right: 0;
  }
}
</style>
